export const phoneExpression: string | undefined = process.env.REACT_APP_PHONE_REG_EXP
export const postalCodeExpression: string | undefined = process.env.REACT_APP_POSTAL_CODE_REG_EXP
export const licenceNumberExpression: string | undefined = process.env.REACT_APP_LICENCE_PATTERN
